import { Component, inject, signal } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';

@Component({
  templateUrl: './error-dialog.component.html',
  styleUrl: './error-dialog.component.scss',
  imports: [MatButtonModule],
})
export class ErrorDialogComponent {
  public dialog = inject(MatDialogRef<ErrorDialogComponent>);
  private data = inject(MAT_DIALOG_DATA) as { title: string; message: string };

  readonly title = signal(this.data.title);
  readonly message = signal(this.data.message);
}
